import React from 'react';
import { ProjectTasksStats } from './ProjectTasksStats';
import { ProjectTasksCalendar } from './ProjectTasksCalendar';
import { ProjectTasksOverdue } from './ProjectTasksOverdue';

export function ProjectTasksSidebar() {
  return (
    <div className="space-y-6">
      {/* Tổng quan công việc & Tiến độ */}
      <ProjectTasksStats />

      {/* Lịch công việc */}
      <ProjectTasksCalendar />

      {/* Công việc quá hạn */}
      <ProjectTasksOverdue />
    </div>
  );
}
